// Dropzone sentences, as pure decisions (fleet observations, 12-Aug).

/** The one-line cue on each dropzone naming the ACTIVE period.
 *
 *  Both live wrong-workspace drops happened because nothing at the drop
 *  target said which period it feeds — the only cue was a small Period
 *  column in Upload History, after the file had already landed. */
export function periodCue(
  label: string | undefined | null,
  tolerance: string | null | undefined,
): string | null {
  if (!label) return null
  const tol = tolerance ? `₹${tolerance}` : '₹1 (default)'
  return `uploading into ${label} — tolerance ${tol}`
}

/** What to say when the sha-dedupe answered with a DIFFERENT filename.
 *
 *  Identical bytes under any name return the stored row (recency bumped) and
 *  the history keeps the OLD filename — correct, and baffling when the toast
 *  pretends the dropped name was uploaded. Null when the names agree. */
export function dedupeNote(
  droppedName: string,
  storedName: string,
): string | null {
  if (droppedName.trim().toLowerCase() === storedName.trim().toLowerCase()) {
    return null
  }
  return `identical to ${storedName} already in this period — re-using it `
    + '(recency refreshed).'
}
